/*
 * Public API Surface of ngx-lib/signature
 */
export * from './signature.module';
export * from './signature.component';
